import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=267d2466&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=267d2466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267d2466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267d2466')) {
      api.createRecord('267d2466', component.options)
    } else {
      api.reload('267d2466', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=267d2466&scoped=true&", function () {
      api.rerender('267d2466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jpFF5Kxbv9a1/JS/comp/DocBox.vue"
export default component.exports